import React from "react";
import {
  Box,
  Chip,
  CircularProgress,
  Divider,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Edit as EditIcon, Delete as DeleteIcon } from "@material-ui/icons";

export default function ToolboxesTable({
  toolboxes,
  loading,
  onRefresh,
  onNew,
  onEdit,
  onDelete,
  TopRightActions,
  NewButton,
}) {
  return (
    <Paper variant="outlined">
      <Box p={2} display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="h6">Toolboxes</Typography>
        <Box display="flex" gridGap={8}>
          {TopRightActions}
          {NewButton}
        </Box>
      </Box>
      <Divider />
      <Box p={2}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Components</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(toolboxes || []).map((tb) => (
              <TableRow key={tb._id} hover>
                <TableCell>{tb.toolbox_name}</TableCell>
                <TableCell style={{ maxWidth: 360 }}>
                  <Typography variant="body2" color="textSecondary" noWrap title={tb.description}>
                    {tb.toolbox_description}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Box display="flex" flexWrap="wrap" gridGap={6}>
                    {(tb.components || []).map((c) => (
                      <Chip key={c} label={c} size="small" color="default" />
                    ))}
                  </Box>
                </TableCell>
                <TableCell align="right">
                  <Tooltip title="Edit">
                    <IconButton onClick={() => onEdit?.(tb)}>
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton onClick={() => onDelete?.(tb)}>
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}

            {!toolboxes?.length && (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  {loading ? (
                    <Box display="flex" alignItems="center" justifyContent="center" py={4}>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <Typography color="textSecondary">
                      No toolboxes yet. Click "New Toolbox" to add one.
                    </Typography>
                  )}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Box>
    </Paper>
  );
}
